<div class="outer-container">
   <a
      href="assets/gtk/hospitalManagerScreenshot.jpg"
      style="text-align: right; margin-bottom: 0px; margin-top: 5px">
      <span style="color: red; font-size: 18px; font-weight: 600; margin-right: 5px">
         <i>* Click here to see newest mockup</i>
      </span>
   </a>

   <div *ngIf="!practiceSKeyNumber">
      <vc-practice-select urlBase="/growth-toolkit/hospital-manager-dashboard" />
   </div>
   <div *ngIf="practiceSKeyNumber">
      <div class="manager-top-row">
         <div class="growth-row-wrapper">
            <div class="practice-status-block">
               <div class="status-left">
                  <div class="practice-name-row">
                     <h3>{{ practiceName }}</h3>
                  </div>
                  <div class="description">
                     Below is a summary of your hospital's progress toward each published goal, including completion status and performance against
                     target values for all active action items.
                  </div>
                  <!--<vc-hospital-kpi-row
               [showHospitalName]="false"
               [showMeeting]="false"
               [showChart]="true"
               [practiceSKey]="practiceSKeyNumber" />-->
               </div>
               <div class="status-right">
                  <img src="assets/gtk/hmTopStats.jpg" />
               </div>
            </div>
         </div>
         <div class="hospital-column-wrapper">
            <vc-hospital-info-column />
         </div>
      </div>

      <div class="action-row">
         <div class="action-text">
            <span class="heading">Your Hospital Goals</span>
            <span class="subtext"></span>
         </div>
         <div class="action-buttons"></div>
      </div>

      <action-item-list
         #actionItemList
         [practiceSKeyNumber]="practiceSKeyNumber"
         [editable]="false" />

      <div *ngIf="!actionItemList?.hasMetricsToDisplay()">You currently have no set hospital goals.</div>
   </div>
   <div class="container-spacer">&nbsp;</div>
</div>
